"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultConnectors = void 0;
const freighter_1 = require("@soroban-react/freighter");
const getDefaultConnectors = ({ appName, chains, }) => {
    const connectors = [
        {
            groupName: 'Popular',
            connectors: [
                (0, freighter_1.freighter)({ appName, chains }),
            ],
        },
    ];
    return {
        connectors,
    };
};
exports.getDefaultConnectors = getDefaultConnectors;
